import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/category/limited-coupons', label: '限时优惠券' },
  { to: '/category/free-resources', label: '免费资源' },
  { to: '/category/member-benefits', label: '会员福利' },
  { to: '/category/points-exchange', label: '积分兑换' },
  { to: '/category/discount-goods', label: '折扣好物' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 no-underline"
          >
            <span className="text-2xl font-bold" style={{ fontFamily: 'var(--font-heading)' }}>
              福利吧
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors duration-200 no-underline ${
                  location.pathname === link.to
                    ? 'text-primary-600 bg-primary-100/70'
                    : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          mobileOpen ? 'max-h-96' : 'max-h-0'
        }`}
      >
        <div className="bg-background-50/95 backdrop-blur-md px-4 pb-4 flex flex-col gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-3 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap transition-colors no-underline ${
                location.pathname === link.to
                  ? 'text-primary-600 bg-primary-100/70'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}